import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import { useProperties } from "../../hooks/useProperties";
import BedIcon from "../../assets/img/homeimg/propertylistings-bedicon.svg";
import PersonIcon from "../../assets/img/homeimg/propertylistings-personicon.svg";
import BatIcon from "../../assets/img/homeimg/propertylistings-bat.svg";
import StarColor from "../../assets/img/homeimg/propertylistings-starwithcolor.svg";
import StarWhite from "../../assets/img/homeimg/propertylistings-starwithoutcolor.svg";
import VrIcon from "../../assets/img/homeimg/discover-firsticon2.svg";

const LatestUpdatesOffers = () => {
  const { properties, loading, error } = useProperties("rent");

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return <section className="overflow-hidden bg-[#F7F7F7] py-10 sm:py-20 lg:py-28">
    <div className="mx-auto max-w-[1480px] px-4 sm:px-6">
      <div data-aos="fade-up" className="mb-14 text-center lg:mb-16">
        <div className="mx-auto max-w-[850px]">
          <div className="mb-4 flex items-center justify-center gap-2">
            <span className="text-[13px] font-medium uppercase tracking-[2px] text-[#1E1E1E] sm:text-[14px]">Featured Rentals</span>
          </div>
          <h2 className="font-[Pochaevsk] text-[34px] font-bold leading-[44px] text-[#1E1E1E] sm:text-[48px] sm:leading-[60px] lg:text-[50px] lg:leading-[68px]">
            Discover Our Latest Rental Properties
          </h2>
          <p className="mt-5 max-w-[850px] font-['Plus_Jakarta_Sans'] text-[13px] uppercase tracking-[1.5px] leading-[26px] text-[#808080] sm:mt-6 sm:text-[14px] sm:leading-[28px]">
            Explore thoughtfully selected villas and apartments available for comfortable living in Spain&apos;s most desirable destinations.
          </p>
        </div>
      </div>

      {loading && <div className="py-16 text-center font-[Poppins] text-[#6F6F6F]">Loading rental properties...</div>}
      {error && <div className="py-16 text-center font-[Poppins] text-red-500">Failed to load rental properties. Please try again.</div>}
      {!loading && !error && <div className="mx-auto grid max-w-[1200px] grid-cols-1 justify-items-center gap-10 md:grid-cols-2 xl:grid-cols-3">
        {properties.slice(0, 3).map((property, index) => {
          const image = property.image_url || "";
          const slug = property.slug || String(property.Reference || property.id).toLowerCase();
          const title = property.title || property.PropertyType?.NameType || "Rental property";
          const location = [property.location || property.Location, property.province || property.Province].filter(Boolean).join(", ");
          return <Link key={property.id || property.Reference || slug} to={`/rent-property/${slug}`} className="group block w-full max-w-[506px]">
            <article data-aos="fade-up" data-aos-delay={index * 100} className="overflow-hidden rounded-[6px] border border-[#E4E4E4] bg-white transition-all duration-500 group-hover:bg-[#181A20]">
              <div className="relative overflow-hidden">
                <img src={image} alt={title} className="h-[320px] w-full object-cover transition-all duration-700 group-hover:scale-110 sm:h-[360px]" />
                <div className="absolute left-5 top-6 flex gap-2">
                  {[StarColor, StarColor, StarColor, StarWhite, StarWhite].map((star, starIndex) => <img key={starIndex} src={star} alt="" className="h-[22px] w-[22px] sm:h-[24px] sm:w-[24px]" />)}
                </div>
                <img src={VrIcon} alt="" className="absolute right-5 top-5 h-[34px] w-[34px] transition-all group-hover:brightness-0 group-hover:invert sm:h-[38px] sm:w-[38px]" />
              </div>
              <div className="p-6 transition-all duration-500 sm:p-7">
                <div className="mb-4 flex items-end gap-2 sm:mb-5"><h3 className="font-[Pochaevsk] text-[28px] leading-none text-[#183346] group-hover:text-white sm:text-[30px]">€{Number(property.Price || 0).toLocaleString()}</h3><span className="mb-[2px] font-[Poppins] text-[15px] text-[#A1A1A1] group-hover:text-white/70 sm:text-[18px]">/month</span></div>
                <h4 className="mb-4 font-[Pochaevsk] text-[18px] leading-[32px] text-[#1F1F1F] group-hover:text-white sm:text-[22px] sm:leading-[38px]">{title}</h4>
                <p className="mb-5 font-[Poppins] text-[15px] text-[#A5A5A5] group-hover:text-white/70 sm:text-[18px]">{location}</p>
                <div className="flex flex-wrap items-center justify-between gap-4">
                  <div className="flex items-center gap-3"><img src={BedIcon} alt="" className="h-6 w-6 group-hover:brightness-0 group-hover:invert" /><span className="font-[Poppins] text-[14px] text-[#4A4A4A] group-hover:text-white sm:text-[16px]">{property.Bedrooms || 0} Bedrooms</span></div>
                  <div className="flex items-center gap-3"><img src={PersonIcon} alt="" className="h-6 w-6 group-hover:brightness-0 group-hover:invert" /><span className="font-[Poppins] text-[14px] text-[#4A4A4A] group-hover:text-white sm:text-[16px]">Rental Ready</span></div>
                  <div className="flex items-center gap-3"><img src={BatIcon} alt="" className="h-6 w-6 group-hover:brightness-0 group-hover:invert" /><span className="font-[Poppins] text-[14px] text-[#4A4A4A] group-hover:text-white sm:text-[16px]">{property.Bathrooms || 0} Bathrooms</span></div>
                </div>
              </div>
            </article>
          </Link>;
        })}
      </div>}
      <div className="mt-12 flex justify-center sm:mt-16">
        <Link to="/rent" className="border border-[#183346] px-6 py-3 font-[Poppins] text-[20px] text-[#183346] transition-colors hover:bg-[#183346] hover:text-white">
          View all rental properties <span aria-hidden="true">-&gt;</span>
        </Link>
      </div>
    </div>
  </section>;
};

export default LatestUpdatesOffers;
